<h2 style="margin:5px 0 10px 0;">Create a New Location Status</h2>
<form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
    <fieldset [disabled]="isReadOnly$ | async">
        <table cellspacing="2" class="attribute-full-width">
            <tr>
                <td>
                    <mat-form-field>
                        <input
                            [attr.data-testid]="'location_status_name_text'"
                            formControlName="name"
                            matInput
                            placeholder="Location Status Name"
                            required
                        />
                        <mat-error *ngIf="form.get('name').invalid">
                            Please enter a Name
                        </mat-error>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field>
                        <input
                            [attr.data-testid]="'location_status_tag_text'"
                            formControlName="tag"
                            matInput
                            pattern="^[A-Z_0-9]*$"
                            placeholder="Location Status Tag"
                            required
                            (focusout)="findTagExists()"
                        >
                        <mat-error *ngIf="form.get('tag').invalid && !form.get('tag').value">
                            Please enter a Standard Tag
                        </mat-error>
                        <mat-error *ngIf="form.get('tag').hasError('pattern') && form.get('tag').value">
                            Please enter a Valid Standard Tag
                        </mat-error>
                        <mat-error *ngIf="form.get('tag').hasError('tagExists') && form.get('tag').touched">
                            Tag already exists! Create a new one.
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>
                    <mat-form-field>
                        <mat-select
                            [attr.data-testid]="'location_status_subtype_text'"
                            formControlName="subType"
                            placeholder="Location Status Sub Type"
                            required
                            (selectionChange)="selectSubType($event.value)"
                        >
                            <mat-option *ngFor="let subType of subTypes" [value]="subType.value">
                                {{subType.label}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('subType').invalid">
                            Please enter a Sub Type
                        </mat-error>
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select
                            [attr.data-testid]="'location_status_category'"
                            formControlName="category"
                            placeholder="Location Status Category"
                            required
                        >
                            <mat-option *ngFor="let category of categories" [value]="category">
                                {{category}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('category').invalid">
                            Please enter a Category
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td *ngIf="showStatusMessage$  | async">
                    <mat-form-field appearance="outline">
                        <textarea
                            [attr.data-testid]="'location_status_status_message_text'"
                            formControlName="statusMessage"
                            matInput
                            matAutosizeMaxRows="6"
                            matAutosizeMinRows="3"
                            matTextareaAutosize
                            placeholder="Location Status Message"
                        ></textarea>
                        <mat-hint>e.g. Inventory Outage Message</mat-hint>
                        <mat-error *ngIf="form.get('subType').value === 'MESSAGING' && form.get('statusMessage').invalid">
                            Please enter a Status Message
                        </mat-error>
                    </mat-form-field>
                </td>
                <td *ngIf="showSubCategory$ | async">
                    <mat-form-field>
                        <mat-select
                            [attr.data-testid]="'location_status_sub_category'"
                            formControlName="subCategory"
                            placeholder="Location Status Sub Category"
                        >
                            <mat-option *ngFor="let subCategory of subCategories" [value]="subCategory">
                                {{subCategory}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('subCategory').invalid">
                            Please enter a Sub Category
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <div  style="margin-top: 30px;" class="flex-center-center">
            <button
                [attr.data-testid]="'cancel_button'"
                class="button-color"
                mat-raised-button
                matTooltip="Cancel creating Location Status"
                type="button"
                style="margin-right: 60px;"
                (click)="onNoClick()"
            >
                Cancel
            </button>
            <button
                [attr.data-testid]="'save_button'"
                class="button-color"
                [disabled]="(isReadOnly$ | async) || form.invalid"
                mat-raised-button
                matTooltip="Submit Location Status"
                type="submit"
            >
                Save
            </button>
        </div>
    </fieldset>
</form>
